import { Box } from '@mui/material';
import { type EdgeProps, useReactFlow } from '@xyflow/react';
import { useRef } from 'react';

import { type ReactFlowStickyNoteNode } from '../../../../types';
import { useReactFlowViewContext } from '../../../context/context';
import { type ReactFlowStickyNoteNodeProps } from '../BlockType/types';
import { STICKY_NOTE_FONT_SIZES } from '../Decorations/constants';

export function StickyNoteTextField(props: ReactFlowStickyNoteNodeProps) {
  const {
    id: nodeId,
    data: { markdownContent, fontSize },
  } = props;
  const { updateNodeData } = useReactFlow<ReactFlowStickyNoteNode, EdgeProps>();
  const { isEditable } = useReactFlowViewContext();
  const fieldRef = useRef<HTMLInputElement>(null);
  return (
    <Box
      component="textarea"
      className="nodrag" // This prevents ReactFlow from dragging the input
      defaultValue={markdownContent}
      disabled={!isEditable}
      onChange={(event) => {
        if (!isEditable) {
          return;
        }
        updateNodeData(nodeId, {
          markdownContent: event.target.value,
        });
      }}
      placeholder="Enter a note..."
      aria-label="Sticky note"
      autoComplete="off"
      onBlur={() => {
        fieldRef.current?.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }}
      ref={fieldRef}
      sx={{
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent',
        outline: 'none',
        border: 'unset',
        resize: 'none',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: 8,
          height: 8,
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          borderRadius: 4,
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'rgba(0, 0, 0, 0.05)',
          borderRadius: 4,
        },
        padding: '0 !important',
        fontSize: STICKY_NOTE_FONT_SIZES[fontSize],
      }}
    />
  );
}
